export var FormItemTypes = {
    SearchSelect: 'SearchSelect',
    TextInput: 'TextInput',
    NumberInput: "NumberInput",
    DatePicker: 'DatePicker',
    TimePicker: 'TimePicker',
    DateTimePicker: 'DateTimePicker',
    CheckBox: 'CheckBox',
    Password: "Password",
    Attachment: "Attachment",
    DateRangePicker: "DateRangePicker",
    DateRangePickerItem: "DateRangePickerItem",
    // Logo: 'Logo',
    CardComponent: "CardComponent",
    ContainerItem: "ContainerItem",
    Accordian: "Accordian",
    Custom: "Custom",
    Box: "Box",
    Button: "Button",
    IconButton: "IconButton",
    Stack: "Stack",
    Typography: "Typography",
    MobileStepper: "MobileStepper",
    Tabs: "Tabs",
    List: "List",
    Divider: "Divider",
    Avatar: "Avatar",
    Chip: "Chip",
    Icon: "Icon",
    SingleSelect: 'SingleSelect',
    Iterator: 'Iterator',
    ErrorsPanel: 'ErrorsPanel'
};
export var NoLabelElementsTypes = [FormItemTypes.Box, FormItemTypes.CardComponent, FormItemTypes.ContainerItem, FormItemTypes.CheckBox, FormItemTypes.Stack, FormItemTypes.Chip, FormItemTypes.Icon, FormItemTypes.Custom];
export var IteratorElements = [FormItemTypes.Iterator, FormItemTypes.List];
export var SurfaceElements = [FormItemTypes.Box, FormItemTypes.CardComponent, FormItemTypes.ContainerItem, FormItemTypes.Stack, FormItemTypes.Accordian];
export var ElementsWithFormLoop = [FormItemTypes.Box, FormItemTypes.CardComponent, FormItemTypes.ContainerItem, FormItemTypes.Stack, FormItemTypes.Accordian, FormItemTypes.Tabs, FormItemTypes.MobileStepper, FormItemTypes.Custom];
export var ElementsWithoutChangeEvent = [FormItemTypes.Box, FormItemTypes.CardComponent, FormItemTypes.ContainerItem, FormItemTypes.Stack, FormItemTypes.Typography, FormItemTypes.Chip, FormItemTypes.Divider, FormItemTypes.Avatar, FormItemTypes.Icon, FormItemTypes.Button, FormItemTypes.IconButton, FormItemTypes.ErrorsPanel];
//------------------------------infer by type------------------------------
